import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { SelectOption } from 'types/common'
import { HandledFrozenFee, PackageSize } from 'types/storeDeliveryFee'
import { SelectBox, TextInput } from 'components/Form'
import { Spacer } from 'components/Utility'

type Props = {
  frozenFees: HandledFrozenFee[]
  handleFrozenFeeAmount: (sizeIndex: number, event: ChangeEvent<HTMLInputElement>) => void
  PACKAGE_SIZES: PackageSize[]
}

const FrozenFeeBySizeForm: FC<Props> = (props) => {
  const { frozenFees, handleFrozenFeeAmount, PACKAGE_SIZES } = props

  return (
    <div className={styles.deliveryFee}>
      <div className={styles.deliveryFee__header}>
        <div className={styles.deliveryFee__header__label}>箱のサイズ</div>
        <Spacer size={8} />
        <div className={styles.deliveryFee__header__label}>追加料金（税抜）</div>
      </div>
      <Spacer size={8} />
      {frozenFees.map((frozenFee, sizeIndex) => {
        const packageSizeOptions: SelectOption<PackageSize>[] = PACKAGE_SIZES.reduce(
          (prev: SelectOption<PackageSize>[], PACKAGE_SIZE) => {
            // 追加済みのサイズは除外（ただし、選択中のサイズは選択肢として含める）
            if (
              frozenFees.some((_frozenFee) => _frozenFee.package_size === PACKAGE_SIZE) &&
              frozenFee.package_size !== PACKAGE_SIZE
            )
              return prev
            return [...prev, { label: PACKAGE_SIZE, value: PACKAGE_SIZE }]
          },
          []
        )
        return (
          <React.Fragment key={frozenFee.package_size}>
            <div className={styles.deliveryFee__body}>
              <div>
                <SelectBox<PackageSize>
                  disabled={true}
                  options={packageSizeOptions}
                  select={() => null}
                  value={frozenFee.package_size}
                />
              </div>
              <Spacer size={8} />
              <div>
                <TextInput
                  disabled={false}
                  onChange={(event) => handleFrozenFeeAmount(sizeIndex, event)}
                  required={true}
                  size={'small'}
                  type={'tel'}
                  value={frozenFee.frozen_fee_amount}
                />
              </div>
            </div>
            {frozenFees.length - 1 !== sizeIndex && <Spacer size={8} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default FrozenFeeBySizeForm
